// src/components/profile/ProfileCompletionNotification.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";
import { Button } from '../ui/button';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const ProfileCompletionNotification = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    const userRole = user?.role || 'student';

    const roleMessage = userRole === 'owner'
        ? 'Complete your owner profile to start listing rooms and mess services on the platform.'
        : 'Complete your student profile to start booking rooms and mess services.';

    const handleBack = () => {
        navigate(-1);
    };

    const handleComplete = () => {
        navigate('/profile/edit');
    };

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center"
        >
            <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-4">
                <AlertCircle className="h-8 w-8 text-yellow-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Profile Incomplete</h2>
            <p className="text-muted-foreground text-sm mb-6">
                {roleMessage}
            </p>
            <div className="flex flex-col gap-2">
                <Button onClick={handleComplete} className="w-full">
                    Complete Your Profile →
                </Button>
                <Button onClick={handleBack} variant="ghost" className="w-full">
                    <ArrowLeft className="h-4 w-4" />
                    Go Back
                </Button>
            </div>
        </motion.div>
    );
};

export default ProfileCompletionNotification;
